//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalBase from '~/components/Shared/ModalBase.vue'
import ModalActionsContainer from '~/components/Shared/ModalActionsContainer.vue'
import Button from '~/components/Shared/Button.vue'
import QuestionsImage from '~/assets/svg/questions.svg'
export default {
  components: {
    ModalBase,
    ModalActionsContainer,
    Button,
    QuestionsImage,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '¡Un momento!',
    },
    mainText: {
      type: String,
      default: '',
    },
    secondaryText: {
      type: String,
      default: '',
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
  },
}
